// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgTinderU: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
      role="presentation"
      {...props}
    >
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M0 4h7.416v6.957c0 1.881.809 4.025 4.572 4.025h.024c3.697 0 4.572-2.144 4.572-4.025V4H24v7.658c0 3.173-1.378 8.882-11.485 8.882H11.51C1.269 20.54 0 14.85 0 11.658z" />
      </g>
    </svg>
  );
};

const Memo = memo(SvgTinderU);
export default Memo;
